<main class="login-page">
  <div *ngIf="choosingCompany" class="company-login-overlay">
    <section class="company-login-dialog" role="dialog" aria-modal="true" aria-labelledby="company-login-title">
      <header><h2 id="company-login-title">Elige tu empresa</h2><p>¿En qué empresa vas a trabajar?</p></header>
      <div class="company-login-list">
        <p *ngIf="companyError" role="alert">{{companyError}}</p>
        <button *ngFor="let company of companies" type="button" [disabled]="companyLoading" (click)="enterCompany(company)">
          <span><strong>{{company.name}}</strong><small>RUC {{company.ruc}}</small></span><span>Entrar →</span>
        </button>
        <p *ngIf="companyLoading" role="status">Cargando…</p>
      </div>
      <footer><button type="button" [disabled]="companyLoading" (click)="cancelCompanySelection()">Cancelar</button><button *ngIf="companyError" type="button" [disabled]="companyLoading" (click)="retryCompanies()">Reintentar</button></footer>
    </section>
  </div>
  <section class="login-shell">
    <div class="login-card">
      <!-- Panel izquierdo -->
      <div class="brand-panel">
        <div class="brand-overlay"></div>
        <div class="brand-content">
          <img
            src="assets/img/Zivo_only_logo.png"
            alt="Logo ZIVO"
            class="brand-logo"
          />

          <h1>ZIVO</h1>
          <span class="brand-subtitle">ERP</span>

          <h2>Bienvenido a ZIVO ERP</h2>
          <div class="brand-line"></div>

          <p>Siempre avanzando a un mundo mejor.</p>

          <p class="brand-small">
            Inicia sesión para acceder a tu entorno de trabajo.
          </p>

          <div class="social-icons">
            <a
              href="https://facebook.com"
              target="_blank"
              aria-label="Facebook"
            >
              <i class="fab fa-facebook-f"></i>
            </a>

            <a href="https://twitter.com" target="_blank" aria-label="Twitter">
              <i class="fab fa-twitter"></i>
            </a>

            <a
              href="https://www.linkedin.com/in/novax-ec-5572153a4/"
              target="_blank"
              aria-label="LinkedIn"
            >
              <i class="fab fa-linkedin-in"></i>
            </a>

            <a href="https://youtube.com" target="_blank" aria-label="YouTube">
              <i class="fab fa-youtube"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Panel derecho -->
      <div class="form-panel">
        <div class="login-container">
          <div class="login-secure-icon">
            <i class="fas fa-lock"></i>
          </div>

          <h2>INICIAR SESIÓN</h2>
          <div class="title-line"></div>

          <form (ngSubmit)="iniciarSesion()" #loginForm="ngForm">
            <div class="form-group">
              <label for="correo">Correo corporativo</label>

              <div class="input-wrapper">
                <i class="far fa-envelope input-icon"></i>

                <input
                  id="correo"
                  [(ngModel)]="correo"
                  name="correo"
                  type="email"
                  placeholder="usuario@novax.ec"
                  required
                />
              </div>
            </div>

            <div class="form-group">
              <label for="contrasena">Contraseña</label>

              <div class="input-wrapper">
                <i class="fas fa-lock input-icon"></i>

                <input
                  id="contrasena"
                  [(ngModel)]="contrasena"
                  name="contrasena"
                  [type]="mostrarPassword ? 'text' : 'password'"
                  placeholder="Ingresa tu contraseña"
                  required
                />

                <button
                  type="button"
                  class="password-toggle"
                  (click)="mostrarPassword = !mostrarPassword"
                  [attr.aria-label]="
                    mostrarPassword
                      ? 'Ocultar contraseña'
                      : 'Mostrar contraseña'
                  "
                >
                  <i
                    class="fas"
                    [ngClass]="mostrarPassword ? 'fa-eye-slash' : 'fa-eye'"
                  ></i>
                </button>
              </div>
            </div>

            <div class="form-options">
              <label class="remember">
                <input
                  type="checkbox"
                  name="recuerdame"
                  [(ngModel)]="recuerdame"
                />
                <span><small>Recordarme (7 días)</small></span>
              </label>

              <a routerLink="/recuperar" class="forgot-inline">
                ¿Olvidaste tu contraseña?
              </a>
            </div>

            <button type="submit" class="login-button">
              <i class="fas fa-sign-in-alt"></i>
              <span>Entrar</span>
            </button>
          </form>

          <p *ngIf="errorMsg" class="error-message">
            <i class="fas fa-circle-exclamation"></i>
            {{ errorMsg }}
          </p>

          <div class="secure-access">
            <span></span>
            <div>
              <i class="fas fa-shield-alt"></i>
              Acceso seguro
            </div>
            <span></span>
          </div>
        </div>
      </div>
    </div>

    <footer class="login-footer">
      <div class="footer-brand">
        <i class="fas fa-shield-alt"></i>
        <span>© 2026 ZIVO ERP</span>

        <span class="footer-separator">·</span>

        <span class="powered-text">Powered by</span>
        <img
          src="assets/img/NOVAXLOGO.png"
          alt="NOVAX EC"
          class="footer-novax-logo"
        />

        <span class="footer-separator">·</span>

        <span>Departamento de Innovación y Tecnología</span>
      </div>

      <strong>Todos los derechos reservados.</strong>
    </footer>

    <!-- MODAL POLÍTICA DE PRIVACIDAD -->
    <div class="login-policy-backdrop" *ngIf="privacyModalOpen">
      <section
        class="login-policy-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Política de privacidad"
      >
        <header class="login-policy-header">
          <div>
            <span>POLÍTICA DE PRIVACIDAD</span>

            <h3>
              {{
                pendingPrivacyPolicy?.title || "Política vigente para empleados"
              }}
            </h3>

            <small>
              Versión:
              {{
                pendingPrivacyPolicy?.version_label ||
                  "v" + pendingPrivacyPolicy?.version
              }}
            </small>
          </div>

          <button
            type="button"
            class="login-policy-close"
            title="Salir"
            (click)="logoutFromPolicyModal()"
            [disabled]="privacySubmitting"
          >
            <i class="fas fa-times"></i>
          </button>
        </header>

        <div class="login-policy-body">
          <div class="login-policy-loading" *ngIf="privacyLoadingPdf">
            <div class="login-policy-loader"></div>
            <span>Cargando documento...</span>
          </div>

          <iframe
            *ngIf="privacyPdfSafeUrl"
            class="login-policy-frame"
            [src]="privacyPdfSafeUrl"
            title="Política de privacidad"
            (load)="onPrivacyPdfLoaded()"
          ></iframe>
        </div>

        <footer class="login-policy-footer">
          <label class="login-policy-check">
            <input
              type="checkbox"
              name="privacyAccepted"
              [(ngModel)]="privacyAccepted"
              [disabled]="privacySubmitting"
            />

            <span>
              He leído y acepto la política de privacidad vigente para continuar
              usando ZIVO ERP.
            </span>
          </label>

          <div class="login-policy-actions">
            <button
              type="button"
              class="login-policy-btn login-policy-btn--secondary"
              (click)="logoutFromPolicyModal()"
              [disabled]="privacySubmitting"
            >
              Salir
            </button>

            <button
              type="button"
              class="login-policy-btn login-policy-btn--primary"
              (click)="acceptPrivacyPolicy()"
              [disabled]="!privacyAccepted || privacySubmitting"
            >
              <i
                class="fas"
                [ngClass]="
                  privacySubmitting ? 'fa-spinner fa-spin' : 'fa-check'
                "
              ></i>

              <span>
                {{
                  privacySubmitting ? "Registrando..." : "Aceptar y continuar"
                }}
              </span>
            </button>
          </div>
        </footer>
      </section>
    </div>
  </section>
</main>
